export const GRAPHQL_ENDPOINT = 'https://soraremedium.wpcomstaging.com/graphql';
